import api from '../api';

import { ParamsBodyValidatePersonalData, ParamsDataValidatePersonalData } from 'utils/typeServices';

export const PostResendToken = async ({ body, token }: ParamsBodyValidatePersonalData) => {
    const bodyJson = JSON.stringify(body);

    try {
        const { data } = await api.post<ParamsDataValidatePersonalData>('v1/Cliente/ReenviarToken', bodyJson, {
            headers: {
                'Authorization': 'Bearer ' + token
            }
        });

        return { data: data };
    } catch (error) {
        console.error('error', error);
        return { data: null };
    }
}
